export default function extractUrl(content: string) {
  const regex =
    /(?:^|\s|[^\w/])(?<url>((https?:\/\/)|(www\.))[\w-]+(?:\.[\w-]+)+(?:[\w.,@?^=%&:/~+#-]*[\w/])?)/gi;
  const match = regex.exec(content);
  if (match) return match.groups?.url || null;
  return null;
}
